import React, { Component } from 'react'

class ShippingPlaceholder extends Component {
  render () {
    return (
      <div className='shipping-form row row-eq-height pt-2 mx-2 pb-2'>
        <div className='col-6 col-md-5 pr-half pt-5 radius bg-ui-3' />

        <div className='shipping-button col-6 col-md-4 form-field pl-half'>
          <button className='btn btn-sm txt-white' disabled>
            &nbsp;
          </button>
        </div>

        <div className='shipping-input col-12 col-md-3 form-field'>
          <div className='row align-items-center h-100'>
            <div className='col-6 mr-auto py-half radius bg-ui-2' />
          </div>
        </div>
      </div>
    )
  }
}

export default ShippingPlaceholder



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductDetail/RedemptionSection/Shipping/ShippingPlaceholder.js